export const environment = {
   // 'API_URL' : 'https://user.youscanme.com/',
   // 'APP_PATH' : 'https://user.youscanme.com/'
   'API_URL' : (window.location.origin.match('localhost') !== null ? 'http://localhost:9090' : 'https://api.youscanme.com' ) ,
   'ASSETS_URL' : (window.location.origin.match('localhost') !== null ? 'http://localhost:9090' : 'https://api.youscanme.com' ) ,
   'APP_PATH' : (window.location.origin.match('localhost') !== null ? 'http://localhost:4300' : 'https://admin.youscanme.com' ) ,
   'LIVE_URL' : (window.location.origin.match('localhost') !== null ? 'http://localhost:4200' : 'https://user.youscanme.com' ) 
}